import { toast } from 'sonner';

export const splitQualiaTaskError = response => {
  const { qualiaTaskError, ...order } = response;
  return { order, qualiaTaskError: qualiaTaskError || null };
};

export const toastOrderUpdateResult = (qualiaTaskError, successMessage) => {
  if (qualiaTaskError) {
    toast.error(qualiaTaskError);
    return;
  }
  if (successMessage) toast.success(successMessage);
};
